export enum SiteRFPPhaseAPIResponse {
  PreRFP = 'preRFP',
  RFP = 'rfp',
  Contracts = 'contracts',
  Derisking = 'derisking',
  Permits = 'permits',
  DeriskingAndPermits = 'deriskingAndPermits',
  NTP = 'ntp',
  PreCon = 'preCon',
  Construction = 'construction',
  Complete = 'complete',
}
